// auth
import ContentFormatXX from '../content/webz/content-format-xx';
import WebbDividerSmall from '../content/webx/webb-divider-sm';
import WebbDividerMedium from '../content/webx/webb-divider-md';

import AuthMailFirebaseModule from '../content/auth/auth-mail-fbaselink';


export default function AuthMailFirebase() {
  
  return (
    <ContentFormatXX 
      head = {'Account Access'}
      home = {`/`}
      link = {`/`}
      form = {'mini'}
      data = {
        <>
          <WebbDividerMedium />
          <AuthMailFirebaseModule />
          
        </>
        
      }  
    /> 
  )
}